import React, { useEffect, useMemo, useState } from "react";
import moment from "moment";
import { BsX } from "react-icons/bs";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Form, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { getMinDateByDate, getMaxDateByDate, formatDate } from "modules/utilities/utility";
import { Popover, Select } from "antd";
import { isEmpty } from "lodash";
import { groupBy } from "lodash";
import { useUserInfo } from "modules/user_management/store";
import FilterIcon from "assets/svgs/filter_icon";

function EngagementDateFilter({
  slotBooking,
  setSelectLead,
  hourEngData,
  setSelectLocation,
  setSelectProcess,
  setFilterOrder,
  submitFlag,
  setSubmitFlag,
  selectLead,
  selectLocation,
  selectProcess,
  attemptStatus,
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const tab = searchParams.get("tab");
  const startUrlDate = new Date(decodeURI(searchParams.get("startDate")));
  const endUrlDate = new Date(decodeURI(searchParams.get("endDate")));

  const [startDate, setStartDate] = useState(startUrlDate);
  const [endDate, setEndDate] = useState(endUrlDate);
  const [groupedAgent, setGroupAgent] = useState({});
  const [groupLocation, setGroupLocation] = useState({});
  const [groupProcess, setGroupProcess] = useState({});
  const { setToaster } = useToast();
  const { fetchUserData, userData } = useUserInfo();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setStartDate(new Date());
    setEndDate(new Date(Date.now() + 30 * 60000));
    isEmpty(userData) && fetchUserData();
  }, []);

  useEffect(() => {
    if (!isEmpty(hourEngData)) {
      const groupedData = {
        agent: groupBy(hourEngData, "reporting_manager"),
        location: groupBy(hourEngData, "location"),
        process: groupBy(hourEngData, "process"),
      };

      setGroupAgent(groupedData.agent);
      setGroupLocation(groupedData.location);
      setGroupProcess(groupedData.process);
    } else {
      setGroupAgent({});
      setGroupLocation({});
      setGroupProcess({});
    }
  }, [hourEngData]);

  const generateOptions = (groupData, labelKey = "label", valueKey = "value", agent=false) => {
    if (!isEmpty(groupData)) {
      return Object.keys(groupData)
        .map((key) => ({
          [labelKey]: key,
          [valueKey]: key,
        }))
        .filter(Boolean);
    }
    return [];
  };

  const agentData = useMemo(() => {
    if (!isEmpty(groupedAgent)) {
      const leadId = Object.keys(groupedAgent);
      return leadId
        .map((lead) => {
          const agentData = userData?.find((item) => item?.user?.id == lead);
          if (agentData) {
            return {
              label: agentData.user.first_name,
              value: agentData.user.id,
            };
          }
        })
        .filter(Boolean);
    }
  }, [groupedAgent, userData]);

  const locationData = useMemo(() => generateOptions(groupLocation), [groupLocation]);
  const processData = useMemo(() => generateOptions(groupProcess), [groupProcess]);

  const updateFilterOrder = (filterType) => {
    setFilterOrder((prevOrder) => {

      if (!prevOrder.includes(filterType)) {
        return [...prevOrder, filterType];
      }
      return prevOrder;
    });
  };

  const handleChange = (value) => {
    setSelectLead(value);
    updateFilterOrder("lead");
  };

  const handleLocation = (value) => {
    setSelectLocation(value);
    updateFilterOrder("location");
  };

  const handleProcess = (value) => {
    setSelectProcess(value);
    updateFilterOrder("process");
  };

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };
  const handleResetStartDate = () => {
    setStartDate(new Date());
  };
  const handleResetEndDate = () => {
    setEndDate(new Date());
  };
  const handleFilterSubmit = (e) => {
    e.preventDefault();
    const sd = moment(startDate);
    const ed = moment(endDate);
    let start;
    let end;

    if (ed.diff(sd, "days") >= 8) {
      setToaster(
        "Date Filter",
        "Please Select date range with in seven days",
        "danger"
      );
      return;
    }

    if (slotBooking) {
      start = startDate ? moment(startDate) : moment().startOf("day");
      end = endDate ? moment(endDate) : moment().endOf("day");
    } else {
      start = startDate
        ? moment(startDate).startOf("day")
        : moment().startOf("day").subtract(7, "days");
      end = endDate ? moment(endDate).endOf("day") : moment().endOf("day");
    }

    navigateByDate(start, end);
  };

  const filterByToday = () => {
    const start = new Date();
    const end = new Date();
    setStartDate(start);
    setEndDate(end);
    navigateByDate(start, end);
  };

  const navigateByDate = (start, end) => {
    if (slotBooking) {
      navigate(
        `/slot-booking-total?tab=${tab}&startDate=${encodeURIComponent(
          start
        )}&endDate=${encodeURIComponent(end)}`
      );
    } else {
      navigate(
        `/engagementReport?tab=${tab}&startDate=${encodeURIComponent(
          start
        )}&endDate=${encodeURIComponent(end)}`
      );
    }
  };

  const content = (
    <div
      className="d-flex flex-column popover-content"
      style={{ width: "20rem", height: "35rem" }}
    >
      {!attemptStatus ? (
        <div className="text-danger fw-bold my-2">
          Please select attempt status, Before selecting this filter.
        </div>
      ) : null}
      <div className="d-flex flex-column gap-5">
        {slotBooking && (
          <Select
            mode="multiple"
            placeholder="Please Select Reporting Manager"
            className="mt-1"
            value={selectLead}
            onChange={handleChange}
            style={{
              width: "20rem",
              marginRight: "1rem",
            }}
            options={agentData}
            allowClear
          />
        )}
        {slotBooking && (
          <Select
            mode="multiple"
            placeholder="Please Select Location"
            className="mt-1"
            value={selectLocation}
            onChange={handleLocation}
            style={{
              width: "20rem",
              marginRight: "1rem",
            }}
            options={locationData}
            allowClear
          />
        )}
        {slotBooking && (
          <Select
            mode="multiple"
            placeholder="Please Select Process"
            className="mt-1"
            value={selectProcess}
            onChange={handleProcess}
            style={{
              width: "20rem",
              marginRight: "1rem",
            }}
            options={processData}
            allowClear
          />
        )}
        <div className="d-flex flex-row justify-content-between">
          <Button onClick={() => setSubmitFlag(0)}>Clear</Button>
          <Button onClick={() => setSubmitFlag(submitFlag + 1)}>Submit</Button>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      {slotBooking ? (
        <div
          className="d-flex justify-content-center align-items-center gap-2"
          style={{ width: "35rem" }}
        >
          <DatePicker
            popperPlacement="bottom-start"
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            className="form-control"
            placeholderText="Select start Time"
            timeIntervals={30}
            dateFormat="h:mm aa"
            showTimeSelect
            showTimeSelectOnly
          />
          <DatePicker
            popperPlacement="bottom-start"
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            className="form-control"
            placeholderText="Select End Time"
            timeIntervals={30}
            dateFormat="h:mm aa"
            showTimeSelect
            showTimeSelectOnly
          />
          <Button
            variant="primary"
            className="mt-1 w-25"
            onClick={handleFilterSubmit}
          >
            Filter
          </Button>
          <Popover
            content={content}
            title="Filter For Engagement"
            trigger="click"
            placement="leftTop"
            visible={visible}
            overlayClassName="popover-border"
          >
            <Button
              type="primary"
              className=" border fs-2 text-white mb-n2 cursor-pointer"
              onClick={() => setVisible(!visible)}
              style={{ height: "2.4rem" }}
            >
              <FilterIcon />
            </Button>
          </Popover>
        </div>
      ) : (
        <Form onSubmit={handleFilterSubmit} className="data-filter">
          <div className="d-flex gap-2">
            <Form.Group>
              <div className="input-container mt-1">
                {startDate ? (
                  ""
                ) : (
                  <div className="calendar-icon-container">
                    <FontAwesomeIcon
                      icon={faCalendarAlt}
                      className="calendar-icon"
                    />
                  </div>
                )}
                <DatePicker
                  selected={startDate}
                  onChange={handleStartDateChange}
                  placeholderText="Start Date"
                  dateFormat="dd-MM-yyyy"
                  value={startDate ? formatDate(startDate) : ""}
                  className="input-with-icon"
                  minDate={getMinDateByDate(endDate)}
                  maxDate={endDate}
                />
                {startDate && (
                  <span className="reset-icon" onClick={handleResetStartDate}>
                    <BsX />
                  </span>
                )}
              </div>
            </Form.Group>
            <Form.Group>
              <div className="input-container mt-1">
                {endDate ? (
                  ""
                ) : (
                  <div className="calendar-icon-container">
                    <FontAwesomeIcon
                      icon={faCalendarAlt}
                      className="calendar-icon"
                    />
                  </div>
                )}
                <DatePicker
                  selected={endDate}
                  onChange={handleEndDateChange}
                  placeholderText="End Date"
                  dateFormat="dd-MM-yyyy"
                  maxDate={getMaxDateByDate(startDate)}
                  minDate={
                    new Date(endDate.getTime() - 2 * 24 * 60 * 60 * 1000)
                  }
                  value={endDate ? formatDate(endDate) : ""}
                />
                {endDate && (
                  <span className="reset-icon" onClick={handleResetEndDate}>
                    <BsX />
                  </span>
                )}
              </div>
            </Form.Group>

            <OverlayTrigger
              overlay={
                <Tooltip
                  style={{ position: "fixed" }}
                  id="overlay-trigger-example"
                >
                  <span className="fw-bold">Filter by Date</span>
                </Tooltip>
              }
            >
              <Button variant="primary" className="mt-1 w-25" type="submit">
                Filter
              </Button>
            </OverlayTrigger>

            {!slotBooking && (
              <OverlayTrigger
                overlay={
                  <Tooltip
                    style={{ position: "fixed" }}
                    id="overlay-trigger-example"
                  >
                    <span className="fw-body">Filter by today</span>
                  </Tooltip>
                }
              >
                <Button
                  variant="primary"
                  className="mt-1 w-25"
                  onClick={filterByToday}
                >
                  Today
                </Button>
              </OverlayTrigger>
            )}
          </div>
        </Form>
      )}
    </div>
  );
}

export default EngagementDateFilter;
